import { ApiClient } from '../ApiClient';

export class CollectionsApi {
  /**
   * Constructs a new CollectionsApi.
   * @alias module:api/CollectionsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.generalApiInstance;
  }

  /**
   * List details of a specific collection
   * @param {String} contractAddress Contract address of the collection
   */
  getCollectionFromAddress({ address }) {
    return this.apiClient.callApi('/collections/{address}', 'get', { address }, {}, null);
  }

  /**
   * List of user owned collections
   * @param {String} address User wallet address
   */
  getCollectionByOwner({ address }) {
    return this.apiClient.callApi('/collections/owner/{address}', 'get', { address }, {}, null);
  }

  getPortfolio(ownerAddress) {
    return this.apiClient.callApi(
      '/collections/portfolio/{ownerAddress}',
      'get',
      { ownerAddress },
      {},
      null,
    );
  }

  getCollectionBidsFromAddress({ address }) {
    return this.apiClient.callApi('/collections/bids/{address}', 'get', { address }, {}, null);
  }

  getLaunchpadCollection(collectionUrl) {
    return this.apiClient.callApi(
      '/collections/launchpad/{collectionUrl}',
      'get',
      { collectionUrl },
      {},
      null,
    );
  }

  getCollectionChart(address) {
    return this.apiClient.callApi('/collections/chart/{address}', 'get', { address }, {}, null);
  }

  cancelCollectionBid(orderKey) {
    return this.apiClient.callApi(
      '/collections/cancelBid/{orderKey}',
      'post',
      { orderKey },
      {},
      null,
    );
  }

  getCollectionHolders(address) {
    return this.apiClient.callApi('/collections/holders/{address}', 'get', { address }, {}, null);
  }

  getFavoriteCollections(address) {
    return this.apiClient.callApi('/collections/favorite/{address}', 'get', { address }, {}, null);
  }
}
